var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"text-center",attrs:{"id":"verify-invalid"}},[_c('i',{staticClass:"fas fa-exclamation-circle"}),_c('h4',[_vm._v(_vm._s(_vm.$t('SignUp.InvalidVerify')))]),_c('h6',{domProps:{"innerHTML":_vm._s(_vm.$t('SignUp.AlreadySignedUp'))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }